import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";
const config = {
  props: [
    {
      prop: "type",
      description:
        "卡片类型(normal: 标准/index: 阴影较浅/content： 阴影较深/transparent: 透明/dark: 深色)",
      type: "String",
      default: "normal"
    }
  ],
  events: [],
  methods: [],
  slots: [
    {
      name: "default",
      description: "卡片内容"
    }
  ]
};
export default DemoPageWrapper(Demo, DemoSource, config);
